import { UpdateMetadataOperation } from '../../../../../team-apis/otterdam/annotation-operations/metadata-operations';
import { TaskWorkspaceState } from '../../../../h3ml/state/task-workspace-state';
import { TaskOperationBuilderParams } from './task-operation-builder-params';

export class UpdateNextShapeIdOperationBuilder {
  private currentTask: TaskWorkspaceState;
  private previousTask: TaskWorkspaceState;

  constructor({ currentTask, previousTask }: TaskOperationBuilderParams) {
    this.currentTask = currentTask;
    this.previousTask = previousTask;
  }

  canBuild() {
    return this.previousTask.nextShapeId !== this.currentTask.nextShapeId;
  }

  build(): UpdateMetadataOperation {
    return {
      operation: 'UPDATE_METADATA',
      attributes: {
        nextShapeId: this.currentTask.nextShapeId,
      },
    };
  }
}
